import Vue from 'vue'
import constants from './constants'
import store from '../store'
var global = {
  UE_TOOL_BAR: [
    'fullscreen', 'source', 'undo', 'redo', '|',
    'removeformat', 'formatmatch', '|',
    'fontsize', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'forecolor', 'backcolor', 'superscript', 'subscript', 'pasteplain', '|',
    'insertorderedlist', 'cleardoc', '|',
    'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
    'directionalityltr', 'directionalityrtl', 'indent', '|',
    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
    'link', 'unlink', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
    'insertimage', 'emotion', 'scrawl', 'insertvideo', 'attachment', 'map', '|',
    'horizontal', 'spechars', '|',
    'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
    'print'
  ],
  SIMPLE_UE_TOOL_BAR: [
    'fullscreen', 'source', 'undo', 'redo', '|',
    'removeformat', 'formatmatch', '|',
    'fontsize', 'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'forecolor', 'backcolor', 'pasteplain', '|',
    'insertorderedlist', 'cleardoc', '|',
    'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
    'directionalityltr', 'directionalityrtl', 'indent', '|',
    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
    'link', 'unlink', '|',
    'insertimage', 'insertvideo', 'attachment'
  ],
  userInfo() {
    const userInfo = store.getters.userInfo
    return userInfo
  },
  organizationInfo() {
    const userInfo = store.getters.userInfo
    var organizationVo = userInfo.cacheOrganizationVo
    if (organizationVo) {
      const org = {
        id: organizationVo.id,
        name: organizationVo.organizationName,
        fullName: organizationVo.organizationFullName,
        code: organizationVo.organizationCode,
        level: organizationVo.organizationLevel,
        regions: JSON.parse(organizationVo.regions)
      }
      return org
    } else {
      throw new Error('当前登录用户少组织机构')
    }
  },
  allowUploadFormats(type) {
    var map = new Map()
    map.set('image', 'png,jpg,jpeg')
    map.set('audio', 'mp3')
    map.set('video', 'swf,flv,mp4,wav,avi')
    map.set('word', 'doc,docx,xls,xlsx,ppt,pptx,txt,pdf')
    map.set('zip', 'rar,zip')
    map.set('file', '*')
    return map.get(type)
  },
  getFileView(uuid) {
    if (uuid) {
      if (uuid && (uuid.indexOf('http://') === 0 || uuid.indexOf('https://') === 0)) {
        return uuid
      } else {
        return `http://47.104.247.47:10013/${constants.WORKFLOW}/fileView/${uuid}?AppId=${constants.APP_ID}&AppKey=${constants.APP_KEY}&ProjectsId=${constants.PROJECTS_ID}`
      }
    } else {
      return '-1'
    }
  },
  getPdfView(uuid, title) {
    if (uuid) {
      if (uuid && (uuid.indexOf('http://') === 0 || uuid.indexOf('https://') === 0)) {
        return uuid
      } else {
        return `${(process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_API : window.g.baseURL)}${constants.WORKFLOW}/fileView/loadPdf/${uuid}/${title}?AppId=${constants.APP_ID}&AppKey=${constants.APP_KEY}&ProjectsId=${constants.PROJECTS_ID}`
      }
    } else {
      return uuid
    }
  }
}

Vue.prototype.global = global
export default global
